import {AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewChildren} from '@angular/core';
import {UtilityService} from '../../../../shared/services/utility.service';
import {ModalDialogV3} from '../../../../shared-modal-dynamic/models/modal-dialog-v3';
import {IDataProcessingAgreementHttpService} from '../../services/data-processing-agreement.http.service.interface';
import {DataProcessingAgreementModel} from '../../../projects/models/data-processing-agreement-model';

@Component({
    selector: 'app-modal-data-processing-agreement-new',
    templateUrl: './modal-data-processing-agreement-new.component.html',
    styleUrl: './modal-data-processing-agreement-new.component.scss'
})
export class ModalDataProcessingAgreementNewComponent extends ModalDialogV3 implements AfterViewInit, OnInit {

    @ViewChildren('focusedButton') fb: any;
    @ViewChild('pdfIframe', {static: true, read: ElementRef}) pdfIframe: ElementRef;


    public static ActionEnum = {
        CONFIRM: 'CONFIRM',
        CANCEL: 'CANCEL'
    };

    private actionEnum = ModalDataProcessingAgreementNewComponent.ActionEnum;


    public agreement: DataProcessingAgreementModel;
    private blob: any;

    public initialized = false;
    public isError = false;

    isAgreed: boolean;


    constructor(private utilityService: UtilityService,
                private dataProcessingAgreementService: IDataProcessingAgreementHttpService) {
        super();
    }


    public async ngOnInit() {
        try {
            this.agreement = (this.modalParams.model as any).agreement
            const pdfContent = this.agreement && this.agreement.agreementFilePDF;
            this.blob = new Blob([this.utilityService.b64toBlob(pdfContent)], {type: 'application/pdf'});
            const agreementUrl = window.URL.createObjectURL(this.blob);
            this.pdfIframe.nativeElement.src = agreementUrl + '#toolbar=0';
            this.initialized = true;
        } catch (e) {
            this.isError = true;
            console.error(e);
        }


    }

    onCancelBtnClicked() {
        this.announceModelChanged({dialogConfirmed: false});
        super.close();

    }

    async onConfirmBtnClicked() {
        try {
            if (this.agreement && this.agreement.id) {
                await this.dataProcessingAgreementService.acceptDataProcessingAgreement(this.agreement.id);
            } else {
                console.warn('dataProcessingAgreement is missing');
            }

            this.announceModelChanged({dialogConfirmed: true});
            super.close();
        } catch (e) {
            console.error(e);
        }

    }

    ngAfterViewInit(): void {
        this.fb.first.nativeElement.focus();
    }

    onDownloadBtnClicked() {
        if (this.blob) {
            const data = window.URL.createObjectURL(this.blob);
            //
            const link = document.createElement('a');
            link.href = data;
            link.download = this.agreement.agreementFileName;

            if (!link.download) {
                link.download = 'agreement.pdf';
            }
            if (link.download.slice(-4).toLowerCase() !== '.pdf') {
                link.download += '.pdf';
            }

            // this is necessary as link.click() does not work on the latest firefox
            link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));

            setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data);
            }, 100);
        } else {
            console.warn('DataProcessingAgreement pdf not found');
        }
    }
}
